import React, { memo, useCallback, useMemo } from 'react';
import DataGrid from "../../../../../components/DataGrid";
import { createUseStyles } from 'hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Table');
const Table = /*#__PURE__*/memo(_ref => {
  var _data$data, _data$data2;
  let {
    data,
    isExpanded
  } = _ref;
  const classes = useStyles();
  const stopPropagation = useCallback(e => {
    if (e) e.stopPropagation();
  }, []);
  const columns = useMemo(() => {
    var _data$columns;
    if (!(data !== null && data !== void 0 && (_data$columns = data.columns) !== null && _data$columns !== void 0 && _data$columns.length)) return [];
    return data.columns.map(column => {
      return {
        field: column.id,
        headerName: column.label
      };
    });
  }, [data === null || data === void 0 ? void 0 : data.columns]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    onMouseDown: stopPropagation
  }, !(data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.length) && /*#__PURE__*/React.createElement("div", {
    className: classes.empty
  }, "is empty"), (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.length) && /*#__PURE__*/React.createElement(DataGrid, {
    rowData: data.data,
    columnDefs: columns,
    defaultColDef: {
      resizable: isExpanded || false
    }
  }));
});
export default Table;